import {Component, Input} from '@angular/core';
import {AssetResultComponent} from "../../assets/asset-result/asset-result.component";
import {TranslatePipe} from "@ngx-translate/core";
import {ReadonlyCollection} from "../collection.model";
import {Subscription} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {CollectionService} from "../collection.service";
import {AssetStateService} from "../../assets/asset.state.service";
import {FilterStateService} from "../../dam-header/filter-state.service";
import {NavStatusService} from "../../nav-status.service";
import {Asset} from "../../assets/asset.model";
import {NavigationPoint} from "../../navigation-point";
import {AssetRenderStyle} from "../../assets/asset-render-style";
import {MatIcon} from "@angular/material/icon";
import {UserStateService} from "../../user/user.state.service";
import {User} from "../../user/user";
import {DateLocalePipe} from "../../common/pipes/date-locale.pipe";


@Component({
    selector: 'app-collection-readonly-view',
    imports: [
        AssetResultComponent,
        TranslatePipe,
        MatIcon,
        DateLocalePipe,
    ],
    templateUrl: './collection-readonly-view.component.html',
    styleUrl: './collection-readonly-view.component.scss'
})
export class CollectionReadonlyViewComponent {

    @Input() id: string = '';

    collection: ReadonlyCollection | null = null;

    totalAssets = 0;
    private assetSub!: Subscription;
    pageInfoSubscription!: Subscription;
    collectionError: boolean = false;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private collectionService: CollectionService,
        private assetStateService: AssetStateService,
        private filterStateService: FilterStateService,
        private navStatusService: NavStatusService,
        private userService: UserStateService
    ) {
    }

    protected readonly AssetRenderStyle = AssetRenderStyle;

    get assets(): Asset[] {
        return this.assetStateService.loadedAssets;
    }
    get user(): User | null {
        return this.userService.user;
    }

    ngOnInit(): void {
        this.navStatusService.setActiveNavPoint(NavigationPoint.collections_readonly);
        this.activatedRoute.params.subscribe(params => {
            let key = params["key"];
            let slug = params["slug"];
            if (key) {
                this.loadSharedCollection(key);
            } else if (slug) {
                this.loadPublicCollection(slug);
            } else {
                console.error('No collection id provided');
            }
        });
        this.filterStateService.setShowFilterBar(true);
        this.pageInfoSubscription = this.assetStateService.pageInfo$.subscribe(res => {
            if (res) {
                this.totalAssets = res.totalItems;
            }
        })
    }

    private loadSharedCollection(key: string) {
        this.collectionService.getSharedCollection(key).subscribe({
            next: (collection) => {
                this.collection = collection;
                this.loadAssets();
            },
            error: () => {
                // console.log('Error loading collection', error);
                this.collectionError = true;
            }
        });
    }

    private loadPublicCollection(slug: string) {
        this.collectionService.getPublishedCollection(slug).subscribe({
            next: (collection) => {
                this.collection = collection;
                this.loadAssets();
            },
            error: () => {
               // console.log('Error loading collection', error);
                this.collectionError = true;
            }
        });
    }

    private loadAssets() {
        this.assetStateService.readonlyCollection$.next(this.collection);
        this.assetStateService.filter = this.assetStateService.createDefaultAssetFilter();
    }

    edit() {
        this.router.navigate(['collections', this.collection!.uuid]);
    }

    ngOnDestroy(): void {
        if (this.assetSub) {
            this.assetSub.unsubscribe();
        }
        if (this.pageInfoSubscription) {
            this.pageInfoSubscription.unsubscribe();
        }

    }
}
